import { QNegozioAgenda } from './QNegozioAgenda';
import React, { useCallback, useEffect, useState } from 'react';
import { appointmentsApi, patientsApi, qNegozioApi } from '../services/api';
import './clinic.css';

const localInput = () => {
  const date = new Date(Date.now() + 3600000);
  date.setMinutes(Math.ceil(date.getMinutes() / 30) * 30, 0, 0);
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
const initialForm = () => ({ patientId: '', startsAt: localInput(), durationMinutes: '30', type: 'Controllo', status: 'Confermato', notes: '' });

export function LocalAgenda() {
  const [items, setItems] = useState([]);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [loadError, setLoadError] = useState('');
  const [saveError, setSaveError] = useState('');
  const [message, setMessage] = useState('');
  const [form, setForm] = useState(initialForm);

  const load = useCallback(async () => {
    setLoading(true);
    setLoadError('');
    try {
      const [appointmentData, patientData] = await Promise.all([appointmentsApi.getAll(), patientsApi.getAll()]);
      setItems(appointmentData || []);
      setPatients(patientData || []);
      setHasLoaded(true);
    } catch (requestError) {
      setLoadError(requestError.message || 'Non è stato possibile caricare l’agenda.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const change = event => {
    setForm(current => ({ ...current, [event.target.name]: event.target.value }));
    setSaveError('');
    setMessage('');
  };

  const save = async event => {
    event.preventDefault();
    if (saving) return;
    setSaving(true);
    setSaveError('');
    setMessage('');
    try {
      await appointmentsApi.create({ ...form, patientId: form.patientId || null, startsAt: new Date(form.startsAt).toISOString(), durationMinutes: Number(form.durationMinutes) });
      setForm(initialForm());
      setMessage('Appuntamento aggiunto all’agenda.');
      await load();
    } catch (requestError) {
      setSaveError(requestError.message || 'Non è stato possibile salvare l’appuntamento.');
    } finally {
      setSaving(false);
    }
  };

  return <div className="clinic-page agenda-state-surface" aria-busy={loading || saving}>
    <div className="clinic-head"><div><h1>Agenda</h1><p>Visite, controlli e appuntamenti collegati alla cartella paziente.</p></div></div>
    {loadError && <div className="agenda-state-error" role="alert"><div><strong>Agenda non aggiornata</strong><span>{loadError}</span></div><button type="button" onClick={load} disabled={loading}>{loading ? 'Nuovo tentativo…' : 'Riprova il caricamento'}</button></div>}
    {message && <div className="agenda-state-success" role="status">{message}</div>}
    <div className="agenda-layout"><form className="clinic-panel clinic-form" onSubmit={save}><div className="clinic-panel-head" style={{padding:'0 0 18px',marginBottom:18}}><h2>Nuovo appuntamento</h2></div>
      {saveError && <div className="agenda-state-form-error" role="alert"><strong>Appuntamento non salvato.</strong> {saveError} I dati inseriti sono rimasti nel modulo: correggili o riprova.</div>}
      <fieldset disabled={saving} className="agenda-state-fieldset"><div className="clinic-grid"><label>Paziente<select name="patientId" value={form.patientId} onChange={change}><option value="">Non associato</option>{patients.map(patient => <option key={patient.id} value={patient.id}>{patient.lastName} {patient.firstName}</option>)}</select></label><label>Data e ora<input required type="datetime-local" name="startsAt" value={form.startsAt} onChange={change}/></label><div className="clinic-grid two"><label>Durata<select name="durationMinutes" value={form.durationMinutes} onChange={change}><option value="30">30 minuti</option><option value="45">45 minuti</option><option value="60">60 minuti</option><option value="90">90 minuti</option></select></label><label>Tipo<select name="type" value={form.type} onChange={change}><option>Prima visita</option><option>Controllo</option><option>BIA</option><option>Consegna dieta</option><option>Altro</option></select></label></div><label>Note<textarea name="notes" value={form.notes} onChange={change}/></label></div><div className="clinic-form-actions"><button className="clinic-button" disabled={saving}>{saving ? 'Salvataggio…' : 'Aggiungi in agenda'}</button></div></fieldset>
    </form><section className="clinic-panel"><div className="clinic-panel-head"><h2>Prossimi appuntamenti</h2>{hasLoaded&&!loading&&<span className="clinic-pill">{items.length}</span>}</div>
      {loading&&!hasLoaded
        ? <div className="agenda-state-loading" role="status">Sto caricando gli appuntamenti…</div>
        : !hasLoaded
          ? <div className="clinic-empty">Agenda non disponibile. Riprova il caricamento.</div>
        : items.length
          ? <div className="timeline-list">{items.map(item => <div className="timeline-row" key={item.id}><div><strong>{new Date(item.startsAt).toLocaleDateString('it-IT')}</strong><br/><small>{new Date(item.startsAt).toLocaleTimeString('it-IT',{hour:'2-digit',minute:'2-digit'})} · {item.durationMinutes} min</small></div><div><strong>{item.patient ? `${item.patient.lastName} ${item.patient.firstName}` : 'Senza paziente'}</strong><br/><small>{item.type}{item.notes ? ` · ${item.notes}` : ''}</small></div><span className="clinic-pill">{item.status}</span></div>)}</div>
          : !loadError && <div className="clinic-empty">Nessun appuntamento in agenda. Usa il modulo per aggiungere il primo.</div>}
    </section></div>
  </div>;
}

export function Agenda() {
  const [status,setStatus]=useState(null),[error,setError]=useState('');
  const load=useCallback(()=>{setError('');qNegozioApi.status().then(setStatus).catch(()=>setError('Impossibile verificare il collegamento dell’agenda.'));},[]);
  useEffect(()=>{load();},[load]);
  if(error)return <div className="clinic-page"><h1>Agenda</h1><p role="alert">{error}</p><button className="clinic-button" onClick={load}>Riprova</button></div>;
  if(!status)return <div className="clinic-page" role="status">Caricamento agenda…</div>;
  return status.configured?<QNegozioAgenda managementUrl={status.managementUrl}/>:<LocalAgenda/>;
}
export default Agenda;
